export const DEFAULT_STATUSES = [
  'Just added',
  'Sent',
  'Replied',
  'Mail ready',
  'Interview Scheduled',
  'Offer',
  'Rejected',
  'No Response',
  'Not interested anymore',
  'Job Closed',
];
